
export default function MaterialiSection() {
  const materials = [
    {
      name: 'Pietra Naturale',
      desc: 'Travertino romano e tufo locale, estratti con metodi sostenibili e lavorati a mano per preservare la tradizione artigianale.',
      image:
        'https://public.readdy.ai/ai/img_res/91d0a17ebdbf19fa3b83fdfce4caf3aa.jpg',
      stat: 'Km Zero',
    },
    {
      name: 'Legno Certificato',
      desc: 'Castagno, rovere e larice provenienti da foreste gestite responsabilmente, con certificazione FSC e PEFC.',
      image:
        'https://readdy.ai/api/search-image?query=close%20up%20of%20premium%20certified%20sustainable%20wood%20planks%20showing%20beautiful%20natural%20grain%20patterns%2C%20warm%20honey%20and%20amber%20tones%2C%20stacked%20wooden%20boards%20with%20visible%20growth%20rings%2C%20soft%20natural%20lighting%20professional%20timber%20material%20photography%2C%20clean%20background&width=500&height=600&seq=mat-legno-v3&orientation=portrait',
      stat: 'FSC Certified',
    },
    {
      name: 'Terra Cruda',
      desc: 'Tecnica millenaria rivisitata con tecnologia moderna. Pareti in terra cruda per un isolamento termico naturale e un comfort acustico superiore.',
      image:
        'https://readdy.ai/api/search-image?query=close%20up%20of%20rammed%20earth%20wall%20showing%20beautiful%20natural%20layers%20and%20striations%20in%20warm%20earth%20tones%2C%20terracotta%20orange%20and%20sandy%20beige%20colors%2C%20smooth%20compacted%20surface%20with%20visible%20texture%2C%20natural%20side%20lighting%20creating%20shadows%20in%20layers%2C%20professional%20architectural%20material%20photography&width=500&height=600&seq=mat-terra-v3&orientation=portrait',
      stat: 'Zero Emissioni',
    },
    {
      name: 'Fibra di Canapa',
      desc: "Isolante naturale ad alte prestazioni, biodegradabile e a bilancio di carbonio negativo. Il futuro dell'edilizia sostenibile.",
      image:
        'https://readdy.ai/api/search-image?query=close%20up%20of%20natural%20hemp%20fiber%20insulation%20material%20for%20sustainable%20building%2C%20golden%20beige%20fibrous%20texture%2C%20compressed%20hemp%20blocks%20showing%20natural%20fibers%2C%20warm%20soft%20lighting%2C%20eco%20friendly%20construction%20material%2C%20professional%20product%20photography%20with%20clean%20minimal%20background&width=500&height=600&seq=mat-canapa-v3&orientation=portrait',
      stat: 'CO\u2082 Negativo',
    },
  ];

  return (
    <section className="py-16 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
            <span className="font-montserrat text-[10px] md:text-[11px] uppercase tracking-[3px] md:tracking-[4px] text-[#6b8e7f]">
              I Nostri Materiali
            </span>
            <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
          </div>
          <h2 className="font-playfair text-[32px] md:text-[52px] font-bold text-[#2d3e40] leading-[1.15]">
            Materia Prima della<br className="hidden md:block" />{' '}
            <em className="text-[#6b8e7f] not-italic">Sostenibilità</em>
          </h2>
          <p className="font-montserrat text-[13px] md:text-[15px] text-[#2d3e40]/60 mt-4 md:mt-6 max-w-[550px] mx-auto leading-[1.8]">
            Ogni materiale racconta una storia di rispetto per la terra. Scegliamo solo ciò che la natura offre senza
            compromessi.
          </p>
        </div>

        {/* Materials Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {materials.map((mat, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative w-full h-[200px] sm:h-[260px] md:h-[320px] rounded-2xl overflow-hidden mb-4 md:mb-5">
                <img
                  src={mat.image}
                  alt={mat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 md:bottom-4 md:left-4">
                  <span className="bg-[#6b8e7f]/90 backdrop-blur-sm text-white font-montserrat text-[9px] md:text-[10px] uppercase tracking-[1px] px-2.5 py-1 md:px-3 md:py-1.5 rounded-md">
                    {mat.stat}
                  </span>
                </div>
              </div>
              <h3 className="font-playfair text-[17px] md:text-[20px] font-bold text-[#2d3e40] mb-1.5 md:mb-2 group-hover:text-[#6b8e7f] transition-colors">
                {mat.name}
              </h3>
              <p className="font-montserrat text-[12px] md:text-[13px] text-[#2d3e40]/55 leading-[1.7]">{mat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
